var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkLikeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66345 10.9307H2.49854V19.7677H6.66345V10.9307Z",
    fill: "#92A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4392 6.20074C17.6919 5.00164 16.9142 3.75604 15.7772 3.3701C15.2257 3.16713 14.6419 3.21257 14.1556 3.37974C13.6708 3.54637 13.207 3.85994 12.9195 4.29047L12.9187 4.29165L9.12834 9.93095H9.10804V9.96115L9.10791 9.96135L9.10804 9.96144V20.7641H9.10818L9.10791 20.7644H18.0737C19.5742 20.7644 20.4194 19.8308 21.0623 18.812C21.7672 17.6952 22.2255 16.5052 22.5661 15.4453C22.7234 14.9556 22.8578 14.4867 22.9781 14.0665L23.0075 13.964C23.1375 13.5108 23.2487 13.1293 23.3606 12.8173C23.6693 11.9566 23.572 11.0993 23.0825 10.4484C22.5996 9.80629 21.8119 9.46704 20.9375 9.46704H17.2183C17.1347 9.46704 17.0711 9.43328 17.0321 9.3892C16.9986 9.35119 16.9607 9.27998 16.9783 9.15084L17.4392 6.20074ZM16.1356 10.4601C16.0947 10.4244 16.0555 10.3867 16.0183 10.3471L16.0078 10.4633L16.1356 10.4601Z",
    fill: "#92A1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46289 11.2268C1.46289 10.3567 2.16822 9.65137 3.03827 9.65137H6.18903C7.05909 9.65137 7.76441 10.3567 7.76441 11.2268V19.7041C7.76441 20.3669 7.22716 20.9041 6.56441 20.9041H3.03827C2.16822 20.9041 1.46289 20.1988 1.46289 19.3287V11.2268ZM3.03827 11.0017C2.91398 11.0017 2.81322 11.1025 2.81322 11.2268V19.3287C2.81322 19.453 2.91398 19.5538 3.03827 19.5538H6.41409V11.2268C6.41409 11.1025 6.31333 11.0017 6.18903 11.0017H3.03827Z",
    fill: "#92A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLikeActive);
export default __webpack_public_path__ + "static/media/dark_like_active.1f94264b48110d00ffb10ace3465c8c6.svg";
export { ForwardRef as ReactComponent };